import { eventBus } from '@/hooks/useEventBus';

class Game {
  constructor(collectibleAssets, time = 60) {
    this.collectibleAssets = collectibleAssets;
    this.collectibleAssetIds = [];
    this.score = 0;
    this.time = time;

    this.collectibleContainer = document.querySelector('#collectables');
    this.collectibleCounter = 0;
    this.elementPositions = [];
  }

  initAssets() {
    return new Promise(resolve => {
      if (this.collectibleAssets && this.collectibleAssets.length > 0) {
        let loadedCount = 0;
        const totalImages = this.collectibleAssets.length;

        this.collectibleAssets.forEach((ele, i) => {
          const img = document.createElement('img');
          img.crossOrigin = 'anonymous';

          img.onload = () => {
            loadedCount++;
            if (loadedCount === totalImages) {
              resolve();
            }
          };

          img.onerror = () => {
            loadedCount++;
            if (loadedCount === totalImages) {
              resolve();
            }
          };

          img.src = ele.uri;
          let id = `collectibe_${i + 1}`;
          img.id = id;
          this.collectibleAssetIds.push(id);
          const assetsEnt = document.querySelector('a-assets');
          if (assetsEnt) assetsEnt.appendChild(img);
        });
      } else {
        resolve();
      }
    });
  }

  initSpanElement() {
    if (this.collectibleCounter >= 8) return;
    const imgSrc =
      this.collectibleAssetIds[
        Math.floor(Math.random() * this.collectibleAssetIds.length)
      ];
    const item = document.createElement('a-plane');

    let x, y, z;
    let attempts = 0;
    let validPosition = false;
    const sphereRadius = 5;

    while (!validPosition && attempts < 10) {
      const theta = Math.random() * Math.PI * 2;
      const phi = Math.acos(2 * Math.random() - 1);

      x = sphereRadius * Math.sin(phi) * Math.cos(theta);
      y = Math.min(1, sphereRadius * Math.cos(phi));
      z = sphereRadius * Math.sin(phi) * Math.sin(theta);

      validPosition = true;
      for (let pos of this.elementPositions) {
        const dx = x - pos.x;
        const dy = y - pos.y;
        const dz = z - pos.z;
        const dist = Math.sqrt(dx * dx + dy * dy + dz * dz);

        if (dist < 3) {
          validPosition = false;
          break;
        }
      }

      attempts++;
    }

    const rotationY = Math.atan2(-x, -z) * (180 / Math.PI);
    const attributes = {
      src: `#${imgSrc}`,
      class: 'clickable',
      scale: '0.5 0.5 0.5',
      position: `${x} ${y} ${z}`,
      rotation: `0 ${rotationY} 0`,
      transparent: 'true',
      side: 'double',
      'depth-write': 'false',
      animation:
        'property: scale; to: 0.6 0.6 0.6; dur: 1000; easing: easeInOutSine; loop: true; dir: alternate',
    };
    for (let key in attributes) {
      item.setAttribute(key, attributes[key]);
    }
    item.addEventListener('click', () => {
      this.score += 100;
      const scoreEl = document.getElementById('score');
      if (scoreEl) scoreEl.innerText = this.score;

      const scorePopup = document.createElement('a-entity');
      const scoreText = document.createElement('a-text');
      scoreText.setAttribute('value', '+100');
      scoreText.setAttribute('align', 'center');
      scoreText.setAttribute('color', '#17b978');
      scoreText.setAttribute('width', '10');
      scoreText.setAttribute('font', 'roboto');
      scoreText.setAttribute('shader', 'msdf');

      scorePopup.appendChild(scoreText);
      scorePopup.setAttribute('position', `${x} ${y - 1} ${z}`);
      scorePopup.setAttribute('rotation', `0 ${rotationY} 0`);
      scorePopup.setAttribute('scale', '1 1 1');
      scorePopup.setAttribute(
        'animation',
        'property: position; to: ' +
          x +
          ' ' +
          (y + 1.5) +
          ' ' +
          z +
          '; dur: 1000; easing: easeOutQuad'
      );
      scorePopup.setAttribute(
        'animation__fade',
        'property: opacity; to: 0; dur: 1000; easing: easeOutQuad'
      );

      this.collectibleContainer.appendChild(scorePopup);

      setTimeout(() => {
        if (scorePopup.parentNode) {
          scorePopup.parentNode.removeChild(scorePopup);
        }
      }, 1000);

      item.setAttribute(
        'animation__click',
        'property: scale; to: 1 1 1; dur: 300; easing: easeOutElastic'
      );
      item.setAttribute(
        'animation__rotate',
        'property: rotation; to: 0 ' +
          (rotationY + 360) +
          ' 0; dur: 500; easing: easeInOutQuad'
      );
      item.setAttribute(
        'animation__fade',
        'property: opacity; to: 0; dur: 400; startEvents: animationcomplete__click'
      );
      setTimeout(() => {
        item.parentNode.removeChild(item);
        this.collectibleCounter -= 1;
        const index = this.elementPositions.findIndex(
          p => p.x === x && p.y === y && p.z === z
        );
        if (index !== -1) {
          this.elementPositions.splice(index, 1);
        }
      }, 500);
    });

    this.collectibleContainer.appendChild(item);
    this.collectibleCounter += 1;

    // Store position for collision detection
    this.elementPositions.push({ x, y, z });
  }

  startTimer() {
    if (this.time <= 0) {
      this.gameOver();
      return;
    }
    this.time = this.time - 1;
    const timeEle = document.getElementById('timer');
    if (timeEle) timeEle.innerText = this.time;
  }

  async startGame() {
    await this.initAssets();
    this.collectibleTimeinterval = setInterval(() => {
      this.initSpanElement();
    }, 1000);
    this.timeinterval = setInterval(() => {
      this.startTimer();
    }, 1000);
  }
  gameOver() {
    eventBus.emit('game_over', { score: this.score });

    clearInterval(this.collectibleTimeinterval);
    clearInterval(this.timeinterval);
  }
}

export default Game;
